// Dependencies
import React from 'react';
import radium from 'radium';
import { connect } from 'react-redux';
import PriceLevelList from './PricelevelList.tsx';
import Title from './Title.jsx';
import LeoHint from '../../../components/hint/LeoHint.jsx';
import {ThemeContext} from "../../../components/theme/Theme.jsx";
// Styles
import './CategoryZone.scss';


function CategoryZone(props: any) {
	const context = React.useContext(ThemeContext);
	const style = {
	};

	return props.categories.length > 0 ?
		(
			<ul className="category-zone" style={style}>
				{props.categories.map((category:any) =>
					<li key={category.categoryUUID} className="category__li">
						<Title name={category.categoryName}>
							{props.availableTicketsPerCategory[category.categoryUUID] < 1 &&
								<LeoHint
									leoHintContainerStyle={{ marginTop: '0em', alignItems: 'baseline' }}
									hintText={context.themeManager.getThemeTextOrHardcodedDefault('categorySoldOutText')}
									popupHeadline={context.themeManager.getThemeTextOrHardcodedDefault('categorySoldOutPopupTitle')}
									popupText={context.themeManager.getThemeTextOrHardcodedDefault('categorySoldOutPopupText')}
								/>
							}
						</Title>
						{props.availableTicketsPerCategory[category.categoryUUID] > 0 &&
							<PriceLevelList
								categoryUuid={category.categoryUUID}
								standardPriceLevel={category.standardPriceLevel}
								reducedPriceLevels={category.reducedPriceLevels}
								ticketsAvailable={props.volatileTicketAvailability[category.categoryUUID]}
							/>
						}
					</li>
				)}
			</ul>
		) : null;
}

const RadiumCategoryZone = radium(CategoryZone);

const calcCategoryTicketsAvailableMap = (state: any, categories: any) => {
	const availableMap: Record<string, string> = {};
	for (const cat of categories) {
		availableMap[cat.categoryUUID] = [cat.standardPriceLevel ? cat.standardPriceLevel.priceLevelUuid : null, ...cat.reducedPriceLevels
			.map((pl:any) => pl.priceLevelUuid)]
		.map((plUuid) => state.eventPage.amountOfTicketsInCart[plUuid]).filter(el => el != null)
		.reduce((accu: any, availablePerPricelevel) => accu + availablePerPricelevel, state.eventPage.volatileTicketAvailability[cat.categoryUUID]);
	}
	return availableMap;
};


// ------------------------------
// Store Connection
// ------------------------------

const mapStateToProps = (state: any, ownProps: any) => {
	const accessCodesEnabled = state.accessCodes.accessCodesEnabled;
	const accessCodePlUuidCodeMap = state.accessCodes.plUuidCodeMap;
	const categories = ownProps.categories;
	const filteredCategoriesWithFilteredPricelevels: any[] = [];

	if (accessCodesEnabled) {
		const accessCodePricelevels = Object.keys(accessCodePlUuidCodeMap);
		categories.forEach((category: any) => {
			if ((accessCodePricelevels.includes(category.standardPriceLevel.priceLevelUuid) || !category.standardPriceLevel.accessCodeNeeded ||
				(category.reducedPriceLevels.find((pl: any) => (accessCodePricelevels.includes(pl.priceLevelUuid) || !pl.accessCodeNeeded))))) {
				const filteredStandardPl = accessCodePricelevels.includes(category.standardPriceLevel.priceLevelUuid) ||
				!category.standardPriceLevel.accessCodeNeeded ?
					category.standardPriceLevel : null;
				const filteredReducedPl = category.reducedPriceLevels.filter((pl:any) =>
						(accessCodePricelevels.includes(pl.priceLevelUuid) || !pl.accessCodeNeeded));
				const categoryWithFilteredPl = Object.assign({}, category, {
					standardPriceLevel: filteredStandardPl,
					reducedPriceLevels: filteredReducedPl,
				});
				filteredCategoriesWithFilteredPricelevels.push(categoryWithFilteredPl);
			}
		});
	}

	return {
		categories: accessCodesEnabled ? filteredCategoriesWithFilteredPricelevels : categories,
		volatileTicketAvailability: state.eventPage.volatileTicketAvailability,
		availableTicketsPerCategory: calcCategoryTicketsAvailableMap(state, categories),
	};
};

const mapDispatchToProps = () => ({
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RadiumCategoryZone);

